// extracted by mini-css-extract-plugin
module.exports = {"characterCountLabel":"characterCountLabel_2F_Gc","characterCount":"characterCount_2IY45","errorColor":"errorColor_JJJsM"};